export function localeFormatNumber(
  number: string,
  locale: string = 'en-US',
): string {
  // TODO japan Intl formatting required?
  return new Intl.NumberFormat(locale).format(parseFloat(number));
}
